import React from "react";
import { Box, Typography } from "@mui/material";
import { Link } from "react-router-dom";
import styles from "../assets/styles/main.module.css";
import Strings from "../utils/stringUtil";
import Routes from "../utils/routesUtil";
import theme from "../utils/themeUtil";
import TextSize from "../utils/textSizeUtil";
import { isMobile } from "../utils/responsiveUtil";
import Seo from "../components/seo";
import withLoader from "../components/ui/withLoader";

function Tnc() {
  return (
    <React.Fragment>
      <Seo
        title={Strings.tncMetaTitle}
        description={Strings.tncMetaDescription}
        keywords={Strings.tncMetaKeyword}
      />
      <Box mt={5} textAlign="left">
        <Box className={styles.container}>
          <Box textAlign="left" my={isMobile ? 2 : 5}>
            <Typography
              style={{
                fontSize: TextSize.size24,
                fontWeight: "bold",
                color: theme.palette.black.main,
              }}
            >
              {Strings.termsConditions}
            </Typography>
          </Box>

          <Box
            style={{ fontSize: "14px", textAlign: "left" }}
            dangerouslySetInnerHTML={{ __html: Strings.tncContent }}
          ></Box>
          <Box mb={3}>
            {[
              {
                route: Routes.RUPEE_CIRCLE_TNC,
                text: Strings.rupeeCircleTnC,
              },
            ].map((item, index) => (
              <Link
                key={index}
                to={item.route}
                className={styles.tncLinks}
                style={{ marginBottom: "8px", display: "block" }}
              >
                <Typography
                  variant="body1"
                  color={theme.palette.blue.main}
                  fontWeight="600"
                >
                  {item.text}
                </Typography>
              </Link>
            ))}
          </Box>

          <Typography
            variant="body1"
            color={theme.palette.lightBlack.main}
            fontWeight="600"
          >
            {Strings.tncLastUpdated}
          </Typography>
        </Box>
      </Box>
    </React.Fragment>
  );
}

export default withLoader(Tnc);
